import { render, staticRenderFns } from "./MemberManagementOnOffboarding.vue?vue&type=template&id=c78e808c"
import script from "./MemberManagementOnOffboarding.vue?vue&type=script&lang=js"
export * from "./MemberManagementOnOffboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports